import { Component, OnInit } from '@angular/core';


declare function isEASite(): boolean;

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})
export class GlobalHeaderComponent implements OnInit {

  public isEqh: boolean = false;
  public isEA: boolean = false;


  ngOnInit() {
	if(isEASite()){
		this.isEA = true;
	}else{
		this.isEqh = true;
	}
  }

}